import { startCase } from "es-toolkit";

import { mapTypeIdToIcon, useMapTypeIdToText } from "@skilitics/designer-ui-components";

export const useMapTypeIdToTarget = () => {
  const mapTypeIdToText = useMapTypeIdToText();

  return (typeId: string) => [
    mapTypeIdToIcon(typeId),
    <span key={typeId}>{startCase(mapTypeIdToText(typeId)).replaceAll("3 D", "3D")}</span>,
  ];
};
